import { setError } from 'src/fetch/common';
import { homeTaxInitData, homeTaxData } from 'src/static/sample/stepC';
import _ from 'lodash';

export const dataStaticSet = (data: any, error: any, errMsg?: string) => {
  // Set Error
  // const errorSet = setError(data, error, errMsg);
  const errorSet = { type: '' };
  const deepData = _.cloneDeep(data);
  const dataSet = deepData;

  const resultSet = {
    resError: errorSet,
    resData: deepData,
  };
  return resultSet;
};

/**
 * User Result 세팅
 */
export const dataSet = (data: any, error: any, errMsg?: string) => {
  // Set Error
  const errorSet = setError(data, error, errMsg);
  // const errorSet = { type: '' };
  const deepData = _.cloneDeep(data);
  const dataSet = deepData;

  const resultSet = {
    resError: errorSet,
    resData: deepData.data?.result,
  };
  return resultSet;
};

/**
 * CREDITCARD Result 세팅
 */
export const creditCardDataSet = (data: any, familyData: any, error: any, errMsg?: string) => {
  // Set Error
  const errorSet = setError(data, error, errMsg);
  const cardData = _.cloneDeep(data)?.data?.result;
  familyData.forEach((item: any) => {
    const credit = cardData.filter((card: any) => card.family_seqid === item.family_seqid);
    item.creditCard = credit;
  });
  const resultSet = {
    resError: errorSet,
    resData: familyData,
  };
  return resultSet;
};

/**
 * INSURFEE Result 세팅
 */
export const insurfeeDataSet = (data: any, familyData: any, error: any, errMsg?: string) => {
  // Set Error
  const errorSet = setError(data, error, errMsg);
  const dataSet: any = _.cloneDeep(data)?.data?.result || [];

  familyData.forEach((item: any) => {
    item.infoData = undefined;
    // if (item.family_type === '1') {
    const setArr: any = [];
    dataSet.forEach((dataItem: any) => {
      if (dataItem.family_seqid === item.family_seqid) {
        dataItem.name = item.name || '';
        setArr.push(dataItem);
      }
    });
    item.infoData = setArr;
    // }
  });
  const resultSet = {
    resError: errorSet,
    resData: familyData,
  };
  return resultSet;
};
/**
 * MEDICAL Result 세팅
 */
export const medicalDataSet = (data: any, familyData: any, error: any, errMsg?: string) => {
  // Set Error
  const errorSet = setError(data, error, errMsg);
  const dataSet = _.cloneDeep(data)?.data?.result;
  familyData.forEach((item: any) => {
    const setData = dataSet.filter((set: any) => set.family_seqid === item.family_seqid);
    item.infoData = setData;
  });
  const resultSet = {
    resError: errorSet,
    resData: familyData,
  };
  return resultSet;
};
/**
 * EDUCATION Result 세팅
 */
export const educationDataSet = (data: any, familyData: any, error: any, errMsg?: string) => {
  // Set Error
  const errorSet = setError(data, error, errMsg);
  const dataSet = _.cloneDeep(data)?.data?.result;
  familyData.forEach((item: any) => {
    const setData = dataSet.filter((set: any) => set.family_seqid === item.family_seqid);
    item.infoData = setData;
  });
  const resultSet = {
    resError: errorSet,
    resData: familyData,
  };
  return resultSet;
};
/**
 * DONATION Result 세팅
 */
export const donationDataSet = (data: any, familyData: any, error: any, errMsg?: string) => {
  // Set Error
  const errorSet = setError(data, error, errMsg);
  const dataSet = _.cloneDeep(data)?.data?.result;
  familyData.forEach((item: any) => {
    const setData = dataSet.filter((set: any) => set.family_seqid === item.family_seqid);
    item.infoData = setData;
  });
  const resultSet = {
    resError: errorSet,
    resData: familyData,
  };
  return resultSet;
};
/**
 * House Loan Result 세팅
 */
export const houseLoanDataSet = (data: any, familyData: any, error: any, errMsg?: string) => {
  // Set Error
  const errorSet = setError(data, error, errMsg);
  const dataSet = _.cloneDeep(data)?.data?.result;
  // familyData.forEach((item: any) => {
  //   const setData = dataSet.filter((set: any) => set.family_seqid === item.family_seqid);
  //   item.infoData = setData;
  // });
  const resultSet = {
    resError: errorSet,
    resData: dataSet,
  };
  return resultSet;
};

/**
 * Result 세팅
 */
export const defDataSet = (data: any, error: any, errMsg?: string) => {
  // Set Error
  const errorSet = setError(data, error, errMsg);
  const dataSet = _.cloneDeep(data)?.data?.result;

  dataSet.forEach((item: any, idx: number) => {
    item.num = idx + 1;
  });

  const resultSet = {
    resError: errorSet,
    resData: dataSet,
  };
  return resultSet;
};

/**
 * Result 세팅
 */
export const settlementDataSet = (data: any, payload: any, error: any, errMsg?: string) => {
  // Set Error
  const errorSet = setError(data, error, errMsg);
  const dataSet = _.cloneDeep(data)?.data?.result || {};
  const totDeterminedPaid =
    dataSet.final_tax || 0 + dataSet.final_tax_local || 0 + dataSet.final_tax_rural || 0; //결정세액
  const totPrePaid =
    dataSet.prepaid_tax || 0 + dataSet.prepaid_tax_local || 0 + dataSet.prepaid_tax_rural || 0; //기납세액
  const totPayablePaid =
    dataSet.withheld_tax || 0 + dataSet.withheld_tax_local || 0 + dataSet.withheld_tax_rural || 0; //차감징수세액
  const totRefundPaid = totPayablePaid < 0 ? totPayablePaid * -1 : totPayablePaid; //환급/납부

  dataSet.totDeterminedPaid = totDeterminedPaid;
  dataSet.totPrePaid = totPrePaid;
  dataSet.totPayablePaid = totPayablePaid;
  dataSet.totRefundPaid = totRefundPaid;

  // Total Set
  payload.total.totDeterminedPaid = totDeterminedPaid;
  payload.total.totPrePaid = totPrePaid;
  payload.total.totPayablePaid = totPayablePaid;
  payload.total.totRefundPaid = totRefundPaid;

  payload.result = dataSet;

  const resultSet = {
    resError: errorSet,
    resData: payload,
  };
  return resultSet;
};

/**
 * Result 세팅
 */
export const settlemenNtstDataSet = (data: any, payload: any, error: any, errMsg?: string) => {
  // Set Error
  const errorSet = setError(data, error, errMsg);
  const dataSet = _.cloneDeep(data)?.data?.result || {};
  if (dataSet.length !== 0) payload.list = dataSet;

  const resultSet = {
    resError: errorSet,
    resData: payload,
  };
  return resultSet;
};

/**
 * User Result 세팅
 */
export const dataIncomeSet = (type: string, data: any, payload: any) => {};
